// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"p-","skip_info":"q-","skipped":"r-","modify_order":"s-","cancel_subscription_btn":"t-","byb":"u-","modify_order_outer":"v-","byb_edit_btn":"w-","modify_order_item":"x-","cancel_copy_wrapper":"y-","cancelled_copy":"z-"};
    if(module.hot) {
      // 1737143664132
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  